import * as React from "react"
import type { IconProps } from "../types"

const ArrowUpCircle = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 24, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill={color}
        ref={ref}
        viewBox="0 0 24 24"
        {...props}
      >
        <path
          fillRule="evenodd"
          d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12ZM7.29289 11.2929L8.70711 12.7071L11 10.4142V17H13V10.4142L15.2929 12.7071L16.7071 11.2929L12 6.58579L7.29289 11.2929Z"
        />
      </svg>
    )
  }
)
ArrowUpCircle.displayName = "ArrowUpCircle"

export default ArrowUpCircle
